import { IMAGES } from "@/data/content";
import { fmtDate, fmtDay, fmtTime } from "@/lib/format";

const img = (u) => (u && u.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);

export const toStory = (s) => ({
  ...s,
  summary: s.shortSummary,
  date: s.publicationDate,
  image: img(s.coverImageUrl),
  imageAlt: s.coverImageAlt || `Cover image for “${s.title}”`,
  domain: (s.researchDomain || []).join(" · "),
});

export const toEvent = (e) => ({
  ...e,
  start: new Date(e.startDateTime),
  end: e.endDateTime ? new Date(e.endDateTime) : null,
  deadline: e.registrationDeadline ? new Date(e.registrationDeadline) : null,
  type: e.eventType,
  domains: e.researchDomain || [],
  domain: (e.researchDomain || [])[0] || "",
  fee: e.feeStatus,
  venue: e.venueName,
  online: e.onlineAccessInfo,
  description: e.fullDescription || e.shortSummary,
  speakers: (e.speakers || []).map((sp) => ({ name: sp.name, role: sp.affiliation })),
});

export const toSlide = ({ kind, item }) =>
  kind === "story"
    ? {
        key: `story:${item.slug}`, kind, typeLabel: item.contentType, title: item.title, summary: item.shortSummary,
        category: item.category, dateLabel: item.publicationDate && fmtDate(item.publicationDate), dateTime: item.publicationDate,
        image: img(item.coverImageUrl), imageAlt: item.coverImageAlt || `Cover image for “${item.title}”`,
        to: `/research/${item.slug}`, cta: "Read Story", isSample: item.isSample,
      }
    : {
        key: `event:${item.slug}`, kind, typeLabel: "Event", title: item.title, summary: item.shortSummary,
        category: (item.researchDomain || [])[0], dateLabel: `${fmtDay(item.startDateTime)} · ${fmtTime(item.startDateTime)}`,
        dateTime: item.startDateTime, image: img(item.posterImageUrl) || IMAGES.audience,
        imageAlt: item.posterImageAlt || (item.posterImageUrl ? `Poster for “${item.title}”` : "Audience seated in a darkened auditorium facing a stage"),
        to: `/events/${item.slug}`, cta: "View Event", isSample: item.isSample,
      };
